import { useQuery } from '@tanstack/react-query'
import { publicAxios } from '../../axios'
import { AxiosResponse } from 'axios'
import { ISpecialty } from '../../../types/specialties'
import { DropdownGetHookReturn } from '../types'
import { useTranslation } from 'react-i18next'

export function useGetSpecialties(): DropdownGetHookReturn<ISpecialty> {
  const path = '/specialties'
  const { i18n } = useTranslation()

  const getSpecialties = useQuery<AxiosResponse<ISpecialty[]>>({
    staleTime: 50000,
    queryKey: [path, i18n.language],
    retry: 1,
    queryFn: async () => {
      const response = await publicAxios.get(path)
      return response
    },
  })
  const result = (getSpecialties.data?.data ?? []) as ISpecialty[]

  return { result, ...getSpecialties }
}
